<template>
  <section
    v-bind:class="slideClasses"
    v-lazy:background-image="backgroundImageSrc"
  >
    <div
      class="overlay"
      v-if="overlayColor"
      v-bind:style="overlayStyle"
    ></div>
    <div class="content">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FullScreenSlide',
  props: ['background-image-src', 'overlay-color'],
  data: function () {
    return {}
  },
  computed: {
    backgroundImageStyle: function () {
      return this.backgroundImageSrc
        ? {backgroundImage: `url('${this.backgroundImageSrc}')`} : {}
    },
    overlayStyle: function () {
      return this.overlayColor ? {backgroundColor: this.overlayColor} : {}
    },
    slideClasses: function () {
      let classes = ['full-screen-slide']
      if (this.overlayColor) {
        classes.push('overlayed')
      }
      return classes
    }
  }
}
</script>

<style scoped lang="scss">
  .full-screen-slide[lazy=loading] {
    background-size: auto;
  }
  .full-screen-slide {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;

    @include media("screen", "<=desktop") {
      height: calc(100vh - #{$the-header-main-height});
    };
    @include media("screen", ">desktop") {
      height: calc(
        100vh - #{$the-header-main-height + $the-header-contacts-height});
    };
    @media print {
      height: auto;
      background: none !important;
      margin-top: 1cm;
      margin-bottom: 1cm;
    }

    &.overlayed {
      position: relative;
      top: 0;
      left: 0;
      & > .content { position: relative; }
    }

    & > .overlay {
      position: absolute;
      width: 100%;
      height: 100%;
    }
    & > .content {
      display: flex;
      align-items: center;
      justify-content: center;

      height: 100%;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/utils/FullScreenSlide.vue